import {getCookie} from '@optimaxdev/utils';
import {captureException, getCurrentScope} from '@sentry/react';

import {isUhcEnabled} from 'libs/rollout';

/**
 * Get visitor Id from cookie
 */
export const getVisitorId = () => getCookie('visitorId');

/**
 * Setup sentry scope with debug information
 * @param {string | {string: any}} [extras=''] - Additional details
 */
function setupSentryScope(extras: string | {} = '') {
    const scope = getCurrentScope();
    scope.setUser({'x-visitor-id': getVisitorId()});
    scope.setContext('additionalDetails', {details: extras});
    scope.setTag('isUhcEnabled', isUhcEnabled());
}

/**
 * Send error to Sentry
 * @param {Error} error - Error object
 * @param {string | {string: any}} [extras=''] - Additional details
 */
export function logWithSentry(error: Error, extras: string | {} = '') {
    setupSentryScope(extras);
    captureException(error);
}

/**
 * Send EEC info in Sentry
 * @param {string} message - string of message
 * @param {object} data - data of event
 */
export const logWithSentryEEC = (
    message: string,
    data?: {
        [key: string]: unknown;
    },
) => {
    getCurrentScope().addBreadcrumb({
        category: 'eec event',
        data,
        level: 'info',
        message,
        type: 'info',
    });
};
